import "../../styles/style"
import "../../image/style"
import "../index.scss"
